import { useEffect, RefObject } from 'react';

type FocusCallback<T> = (ref: RefObject<T>) => void;
function useOnFocusedRef<T extends HTMLElement>(ref: RefObject<T>, focusCallback: FocusCallback<T>): void {
  useEffect(() => {
    const ele = ref?.current;

    function handleFocusIn(): void {
      focusCallback(ref);
    }
    ele?.addEventListener('focusin', handleFocusIn);
    return () => {
      ele?.removeEventListener('focusin', handleFocusIn);
    };
  }, [ref, focusCallback]);
}

export default useOnFocusedRef;
